import React from 'react';
import PropTypes from 'prop-types';
import List from 'widgets/List';
import colors from 'assets/styles/jsVariables/colors';

const styles = {
  labelTextRoot: {
    fontSize: '14px',
    lineHeight: '16px'
  }
};

export default function CountryItem({ countryCode, countryName, onClick }) {
  return (
    <List
      button
      type="listItem"
      style={{ color: colors.darkGrey, paddingLeft: 25 }}
      onClick={() => onClick({ countryCode, countryName })}
    >
      <List type="listItemText" cssStyles={{ root: styles.labelTextRoot }}>
        { countryName }
      </List>
    </List>
  );
}

CountryItem.propTypes = {
  countryCode: PropTypes.string.isRequired,
  countryName: PropTypes.string.isRequired,
  onClick: PropTypes.func
};

CountryItem.defaultProps = {
  onClick: () => {}
};



// WEBPACK FOOTER //
// ./src/components/CountryDrop/CountryItem.jsx